import React from 'react';
import { sortByAlpha, sortable } from '../../../../helpers/sorters';

const CheckboxValue = ({
  field,
  response,
  isEditing,
  adminField,
  handleResponseOptionUpdate,
}) => {
  const width =
    field.width === 1 ? 'full' : field.width === 2 ? 'half' : 'third';
  const alphaSorted = field.alpha || false;
  const checkedOptionIDs = response
    ? response.response_options.map((ro) => ro.option_id)
    : [];

  const sortedFieldOptions = alphaSorted
    ? sortByAlpha(field.options, 'value')
    : sortable(field.options);

  const responseOptions = response
    ? sortedFieldOptions
        .filter((opt) =>
          response.response_options.map((ro) => ro.option_id).includes(opt.id)
        )
        .map((ro) => ro.value)
    : '';

  return (
    <div className={'input-group ' + width}>
      <label
        className={
          checkedOptionIDs.length > 0 || isEditing || adminField ? '' : 'empty'
        }
      >
        {field.name + ': '}
      </label>
      {adminField && field.help_text && (
        <p className='admin-help-text'>{field.help_text}</p>
      )}
      {isEditing || adminField ? (
        <div className='checkbox-input'>
          {sortedFieldOptions.map((opt) => {
            return (
              <div className='checkbox-group' key={opt.id}>
                <input
                  type='checkbox'
                  id={'option_' + opt.id}
                  checked={checkedOptionIDs.includes(opt.id)}
                  onChange={(e) =>
                    handleResponseOptionUpdate(e, response, opt.id)
                  }
                />
                <label htmlFor={'option_' + opt.id}>{opt.value}</label>
              </div>
            );
          })}
        </div>
      ) : (
        responseOptions && (
          <ul>
            {responseOptions.map((value, index) => (
              <li key={response.id + '-' + index}>{value}</li>
            ))}
          </ul>
        )
      )}
    </div>
  );
};

export default CheckboxValue;
